import { useVisibleAxesScales } from './useVisibleAxesScales.js';
import type { AnyScale } from '../../core/types/scales.js';

type UseGetVisibleAxesScales = () =>
  | {
      xScale: null;
      yScale: null;
      hasXAndYScale: false;
    }
  | {
      xScale: AnyScale;
      yScale: AnyScale;
      hasXAndYScale: true;
    };

export const useGetVisibleAxesScales: UseGetVisibleAxesScales = () => {
  const { top, bottom, left, right } = useVisibleAxesScales();

  const xScale = bottom || top;
  const yScale = left || right;
  const hasXAndYScale = !!(xScale && yScale);

  if (hasXAndYScale) {
    return {
      hasXAndYScale: true,
      xScale,
      yScale,
    };
  }

  return {
    hasXAndYScale: false,
    xScale: null,
    yScale: null,
  };
};
